import { ProcesarDatosApi } from "../api/ApiFetch";
const controladorTecnologia = "vacante";

export const ObtenerVacantes = async () => {


    const url = `${controladorTecnologia}/ObtenerVacantes`;
    return await ProcesarDatosApi('GET', url);
}

export const ObtenerVacantesCompleto = async () => {
    const url = `${controladorTecnologia}/ObtenerVacantesCompleto`;
    return await ProcesarDatosApi('GET', url);
}

export const EditarVacantes = async (data) => {
    const url = `${controladorTecnologia}/EditarVacantes`;
    return await ProcesarDatosApi('PUT', url, data);
}

export const EditarInactivoVacantes = async (data) => {
    const url = `${controladorTecnologia}/EditarInactivoVacantes`;
    return await ProcesarDatosApi('PUT', url, data);
}

export const AgregarVacantes = async (data) => {
    const url = `${controladorTecnologia}/AgregarVacantes`;
    return await ProcesarDatosApi('POST', url, data);
}
